/**
 * LINE feature の公開パス定義（middleware 認証バイパス）
 *
 * - /line/reserve: LIFF 見学予約フォーム（LINEアプリ内WebView。認証はLIFF IDトークンで
 *   API 側が行うため、ページ自体はセッション不要の公開ページ）
 * - /line/go: 計測してから外部サイトへ飛ぶ LIFF リダイレクトページ（dest キーのみ受付）
 * - /line/pdf: 資料PDF ビューワー LIFF ページ（PDF URL はサーバー側で解決）
 * - /line/diag は公開パスから除外（本番露出封じ・2026-07-11）。開発用の LIFF 診断ページのため
 *   認証必須にして本番で第三者が開けないようにする（middleware が非公開ページとして扱う）。
 * - /line/faq: リッチメニュー「よくある質問」の遷移先。line_faq_items を読み取り専用で
 *   表示する公開 LIFF ページ（認証不要・書き込みなし。2026-07-07 追加）
 * - /line/request-docs: LIFF 資料請求フォーム（本名未確定のお客様の名寄せ入口。
 *   送信APIは LIFF ID トークンで保護）
 * - /line/survey: LIFF 版 V5 アンケート（見学会当日にお客様のスマホで回答。
 *   送信APIは LIFF ID トークンで保護・保存は既存 V5 保存ロジックへ委譲）
 * - /line/cases: 施工事例ギャラリー LIFF ページ（写真閲覧のみ・書込APIなし。
 *   閲覧計測は /api/line/track へ signedToken 経由でPOSTするベストエフォート）
 * - /line/content: 動画・Podcast コンテンツ一覧 LIFF ページ（読み取り専用・書込APIなし。
 *   視聴計測は /api/line/track へ signedToken 経由でPOSTするベストエフォート。/line/cases と同性質。
 *   リッチメニュー「動画・Podcast」ボタン(/line/go?dest=content)の最終遷移先。2026-07-10 追加）
 * - /line/media: リッチメニュー「動画」ボタンの遷移先。Gハウス公式YouTube 2チャンネル＋
 *   Spotify Podcast の3導線から選ぶ選択画面（書込なし・各リンクは /line/go?dest=... の計測経由）。
 *   西野さん指定・2026-07-11 追加。
 * - /api/line: LIFF から呼ぶ予約・行動ログ・資料請求・アンケートAPI群。各 route が
 *   LIFF ID トークン検証・署名検証で保護する（セッション認証ではないため middleware では
 *   素通しし、認可は route 層が担う）
 */
export const LINE_PUBLIC_PATHS = {
  pages: [
    '/line',
    '/line/reserve',
    '/line/go',
    '/line/pdf',
    '/line/faq',
    '/line/request-docs',
    '/line/survey',
    '/line/cases',
    '/line/content',
    '/line/media',
  ],
  apis: ['/api/line'],
} as const
